import { lazy } from '@/service/lazy'

export default [{
  name: 'Promotora',
  path: 'promotora',
  id: 'promotora',
  icon: 'fa fa-bank',
  component: lazy('app/default/promotora/index'),
  meta: { requireAuth: true, rules: ['troca_promotora'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/promotora.js